import {atom} from "recoil";

/**
 * 수신함 상신문서 갯수
 * @type {RecoilState<number>}
 */
export const receiveApprovalCheckCount = atom({
    key: "receiveApprovalCheckCount"
    , default: 0
})